var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"numbers"},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.n))]),(_vm.total)?_c('div',{staticClass:"total"},[_vm._v(_vm._s(_vm.total))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }